export const CALCULATION_TYPES = ['calculated', 'notCalculated'];
export const DIFFICULTY_LEVELS = ['easy', 'medium', 'hard'];
